import { useState, useEffect } from "react"
import { useRouter } from "next/router"

export default function Search() {
  const router = useRouter()
  // console.log(router)
  const [text, setText] = useState(router?.query?.q || "")

  function onSearch() {
    if (text.length > 0) router.push(`/tim-kiem?q=${text}`)
  }

  function onChange(e) {
    setText(e.target.value)
  }

  function onKeyPress(e) {
    if (e.keyCode === 13 && text.length > 0) {
      router.push(`/tim-kiem?q=${text}`)
    }
  }

  useEffect(() => {
    // console.log(router)
    if (router.pathname !== "/tim-kiem") setText("")
  }, [router])

  return (
    <div className="relative hover:opacity-70">
      <input
        value={text}
        onChange={onChange}
        onKeyDown={onKeyPress}
        className="rounded-xl text-xl leading-5 text-[#AFAFAF] bg-[#2E2E2E] px-4 py-2 pl-12 w-[496px] search-cancel:cursor-pointer search-cancel:h-6 search-cancel:w-6 search-cancel:appearance-none search-cancel:bg-no-repeat search-cancel:bg-[url(/iconCloseSearch.svg)]"
        placeholder="Tìm kiếm"
        type="search"
      />
      <button
        onClick={onSearch}
        className="absolute left-4 z-20 top-1/2 transform -translate-y-1/2 rounded cursor-pointer"
      >
        <img src="/icons/iconSearch.svg" />
      </button>
    </div>
  )
}
